'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _boardLink = require('./jsx/board-link');

var _boardLink2 = _interopRequireDefault(_boardLink);

var _boardLocked = require('./jsx/board-locked');

var _boardLocked2 = _interopRequireDefault(_boardLocked);

var _boardSharedUsers = require('./jsx/board-shared-users');

var _boardSharedUsers2 = _interopRequireDefault(_boardSharedUsers);

var _chevronLeft = require('./jsx/chevron-left');

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _closeXSmall = require('./jsx/close-x-small');

var _closeXSmall2 = _interopRequireDefault(_closeXSmall);

var _closeX = require('./jsx/close-x');

var _closeX2 = _interopRequireDefault(_closeX);

var _crossLarge = require('./jsx/cross-large');

var _crossLarge2 = _interopRequireDefault(_crossLarge);

var _crossSmall = require('./jsx/cross-small');

var _crossSmall2 = _interopRequireDefault(_crossSmall);

var _elementBoard = require('./jsx/element-board');

var _elementBoard2 = _interopRequireDefault(_elementBoard);

var _elementCard = require('./jsx/element-card');

var _elementCard2 = _interopRequireDefault(_elementCard);

var _elementColumn = require('./jsx/element-column');

var _elementColumn2 = _interopRequireDefault(_elementColumn);

var _elementImage = require('./jsx/element-image');

var _elementImage2 = _interopRequireDefault(_elementImage);

var _elementLine = require('./jsx/element-line');

var _elementLine2 = _interopRequireDefault(_elementLine);

var _elementLink = require('./jsx/element-link');

var _elementLink2 = _interopRequireDefault(_elementLink);

var _elementResizeHandle = require('./jsx/element-resize-handle');

var _elementResizeHandle2 = _interopRequireDefault(_elementResizeHandle);

var _errorAlert = require('./jsx/error-alert');

var _errorAlert2 = _interopRequireDefault(_errorAlert);

var _exportMarkdown = require('./jsx/export-markdown');

var _exportMarkdown2 = _interopRequireDefault(_exportMarkdown);

var _exportPdf = require('./jsx/export-pdf');

var _exportPdf2 = _interopRequireDefault(_exportPdf);

var _exportText = require('./jsx/export-text');

var _exportText2 = _interopRequireDefault(_exportText);

var _exportWord = require('./jsx/export-word');

var _exportWord2 = _interopRequireDefault(_exportWord);

var _greenTick = require('./jsx/green-tick');

var _greenTick2 = _interopRequireDefault(_greenTick);

var _helpCenter = require('./jsx/help-center');

var _helpCenter2 = _interopRequireDefault(_helpCenter);

var _imageFormUpload = require('./jsx/image-form-upload');

var _imageFormUpload2 = _interopRequireDefault(_imageFormUpload);

var _imagePopupUpload = require('./jsx/image-popup-upload');

var _imagePopupUpload2 = _interopRequireDefault(_imagePopupUpload);

var _inboxEmpty = require('./jsx/inbox-empty');

var _inboxEmpty2 = _interopRequireDefault(_inboxEmpty);

var _linkFail = require('./jsx/link-fail');

var _linkFail2 = _interopRequireDefault(_linkFail);

var _linkIcon = require('./jsx/link-icon');

var _linkIcon2 = _interopRequireDefault(_linkIcon);

var _menuDownArrow = require('./jsx/menu-down-arrow');

var _menuDownArrow2 = _interopRequireDefault(_menuDownArrow);

var _milanoteLogoLarge = require('./jsx/milanote-logo-large');

var _milanoteLogoLarge2 = _interopRequireDefault(_milanoteLogoLarge);

var _milanoteLogoSmall = require('./jsx/milanote-logo-small');

var _milanoteLogoSmall2 = _interopRequireDefault(_milanoteLogoSmall);

var _navAntenna = require('./jsx/nav-antenna');

var _navAntenna2 = _interopRequireDefault(_navAntenna);

var _navCreate = require('./jsx/nav-create');

var _navCreate2 = _interopRequireDefault(_navCreate);

var _navExport = require('./jsx/nav-export');

var _navExport2 = _interopRequireDefault(_navExport);

var _navHelp = require('./jsx/nav-help');

var _navHelp2 = _interopRequireDefault(_navHelp);

var _navNotifications = require('./jsx/nav-notifications');

var _navNotifications2 = _interopRequireDefault(_navNotifications);

var _navSearch = require('./jsx/nav-search');

var _navSearch2 = _interopRequireDefault(_navSearch);

var _paymentFree = require('./jsx/payment-free');

var _paymentFree2 = _interopRequireDefault(_paymentFree);

var _paymentIndividual = require('./jsx/payment-individual');

var _paymentIndividual2 = _interopRequireDefault(_paymentIndividual);

var _paymentStar = require('./jsx/payment-star');

var _paymentStar2 = _interopRequireDefault(_paymentStar);

var _paymentTeam = require('./jsx/payment-team');

var _paymentTeam2 = _interopRequireDefault(_paymentTeam);

var _paymentTrophy = require('./jsx/payment-trophy');

var _paymentTrophy2 = _interopRequireDefault(_paymentTrophy);

var _playArrow = require('./jsx/play-arrow');

var _playArrow2 = _interopRequireDefault(_playArrow);

var _tick = require('./jsx/tick');

var _tick2 = _interopRequireDefault(_tick);

var _toolbarArrowLeftOn = require('./jsx/toolbar-arrow-left-on');

var _toolbarArrowLeftOn2 = _interopRequireDefault(_toolbarArrowLeftOn);

var _toolbarArrowLeft = require('./jsx/toolbar-arrow-left');

var _toolbarArrowLeft2 = _interopRequireDefault(_toolbarArrowLeft);

var _toolbarArrowRightOn = require('./jsx/toolbar-arrow-right-on');

var _toolbarArrowRightOn2 = _interopRequireDefault(_toolbarArrowRightOn);

var _toolbarArrowRight = require('./jsx/toolbar-arrow-right');

var _toolbarArrowRight2 = _interopRequireDefault(_toolbarArrowRight);

var _toolbarBoldOn = require('./jsx/toolbar-bold-on');

var _toolbarBoldOn2 = _interopRequireDefault(_toolbarBoldOn);

var _toolbarBold = require('./jsx/toolbar-bold');

var _toolbarBold2 = _interopRequireDefault(_toolbarBold);

var _toolbarCaptionOn = require('./jsx/toolbar-caption-on');

var _toolbarCaptionOn2 = _interopRequireDefault(_toolbarCaptionOn);

var _toolbarCaption = require('./jsx/toolbar-caption');

var _toolbarCaption2 = _interopRequireDefault(_toolbarCaption);

var _toolbarChecklistOn = require('./jsx/toolbar-checklist-on');

var _toolbarChecklistOn2 = _interopRequireDefault(_toolbarChecklistOn);

var _toolbarChecklist = require('./jsx/toolbar-checklist');

var _toolbarChecklist2 = _interopRequireDefault(_toolbarChecklist);

var _toolbarH1On = require('./jsx/toolbar-h1-on');

var _toolbarH1On2 = _interopRequireDefault(_toolbarH1On);

var _toolbarH = require('./jsx/toolbar-h1');

var _toolbarH2 = _interopRequireDefault(_toolbarH);

var _toolbarImagePreviewOn = require('./jsx/toolbar-image-preview-on');

var _toolbarImagePreviewOn2 = _interopRequireDefault(_toolbarImagePreviewOn);

var _toolbarImagePreview = require('./jsx/toolbar-image-preview');

var _toolbarImagePreview2 = _interopRequireDefault(_toolbarImagePreview);

var _toolbarItalicOn = require('./jsx/toolbar-italic-on');

var _toolbarItalicOn2 = _interopRequireDefault(_toolbarItalicOn);

var _toolbarItalic = require('./jsx/toolbar-italic');

var _toolbarItalic2 = _interopRequireDefault(_toolbarItalic);

var _toolbarListOn = require('./jsx/toolbar-list-on');

var _toolbarListOn2 = _interopRequireDefault(_toolbarListOn);

var _toolbarList = require('./jsx/toolbar-list');

var _toolbarList2 = _interopRequireDefault(_toolbarList);

var _toolbarLockOn = require('./jsx/toolbar-lock-on');

var _toolbarLockOn2 = _interopRequireDefault(_toolbarLockOn);

var _toolbarLock = require('./jsx/toolbar-lock');

var _toolbarLock2 = _interopRequireDefault(_toolbarLock);

var _toolbarNumlistOn = require('./jsx/toolbar-numlist-on');

var _toolbarNumlistOn2 = _interopRequireDefault(_toolbarNumlistOn);

var _toolbarNumlist = require('./jsx/toolbar-numlist');

var _toolbarNumlist2 = _interopRequireDefault(_toolbarNumlist);

var _toolbarQuoteOn = require('./jsx/toolbar-quote-on');

var _toolbarQuoteOn2 = _interopRequireDefault(_toolbarQuoteOn);

var _toolbarQuote = require('./jsx/toolbar-quote');

var _toolbarQuote2 = _interopRequireDefault(_toolbarQuote);

var _toolbarTransparentOn = require('./jsx/toolbar-transparent-on');

var _toolbarTransparentOn2 = _interopRequireDefault(_toolbarTransparentOn);

var _toolbarTransparent = require('./jsx/toolbar-transparent');

var _toolbarTransparent2 = _interopRequireDefault(_toolbarTransparent);

var _toolbarTrash = require('./jsx/toolbar-trash');

var _toolbarTrash2 = _interopRequireDefault(_toolbarTrash);

var _userGuest = require('./jsx/user-guest');

var _userGuest2 = _interopRequireDefault(_userGuest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    'board-link': _boardLink2.default,
    'board-locked': _boardLocked2.default,
    'board-shared-users': _boardSharedUsers2.default,
    'chevron-left': _chevronLeft2.default,
    'close-x-small': _closeXSmall2.default,
    'close-x': _closeX2.default,
    'cross-large': _crossLarge2.default,
    'cross-small': _crossSmall2.default,
    'element-board': _elementBoard2.default,
    'element-card': _elementCard2.default,
    'element-column': _elementColumn2.default,
    'element-image': _elementImage2.default,
    'element-line': _elementLine2.default,
    'element-link': _elementLink2.default,
    'element-resize-handle': _elementResizeHandle2.default,
    'error-alert': _errorAlert2.default,
    'export-markdown': _exportMarkdown2.default,
    'export-pdf': _exportPdf2.default,
    'export-text': _exportText2.default,
    'export-word': _exportWord2.default,
    'green-tick': _greenTick2.default,
    'help-center': _helpCenter2.default,
    'image-form-upload': _imageFormUpload2.default,
    'image-popup-upload': _imagePopupUpload2.default,
    'inbox-empty': _inboxEmpty2.default,
    'link-fail': _linkFail2.default,
    'link-icon': _linkIcon2.default,
    'menu-down-arrow': _menuDownArrow2.default,
    'milanote-logo-large': _milanoteLogoLarge2.default,
    'milanote-logo-small': _milanoteLogoSmall2.default,
    'nav-antenna': _navAntenna2.default,
    'nav-create': _navCreate2.default,
    'nav-export': _navExport2.default,
    'nav-help': _navHelp2.default,
    'nav-notifications': _navNotifications2.default,
    'nav-search': _navSearch2.default,
    'payment-free': _paymentFree2.default,
    'payment-individual': _paymentIndividual2.default,
    'payment-star': _paymentStar2.default,
    'payment-team': _paymentTeam2.default,
    'payment-trophy': _paymentTrophy2.default,
    'play-arrow': _playArrow2.default,
    'tick': _tick2.default,
    'toolbar-arrow-left-on': _toolbarArrowLeftOn2.default,
    'toolbar-arrow-left': _toolbarArrowLeft2.default,
    'toolbar-arrow-right-on': _toolbarArrowRightOn2.default,
    'toolbar-arrow-right': _toolbarArrowRight2.default,
    'toolbar-bold-on': _toolbarBoldOn2.default,
    'toolbar-bold': _toolbarBold2.default,
    'toolbar-caption-on': _toolbarCaptionOn2.default,
    'toolbar-caption': _toolbarCaption2.default,
    'toolbar-checklist-on': _toolbarChecklistOn2.default,
    'toolbar-checklist': _toolbarChecklist2.default,
    'toolbar-h1-on': _toolbarH1On2.default,
    'toolbar-h1': _toolbarH2.default,
    'toolbar-image-preview-on': _toolbarImagePreviewOn2.default,
    'toolbar-image-preview': _toolbarImagePreview2.default,
    'toolbar-italic-on': _toolbarItalicOn2.default,
    'toolbar-italic': _toolbarItalic2.default,
    'toolbar-list-on': _toolbarListOn2.default,
    'toolbar-list': _toolbarList2.default,
    'toolbar-lock-on': _toolbarLockOn2.default,
    'toolbar-lock': _toolbarLock2.default,
    'toolbar-numlist-on': _toolbarNumlistOn2.default,
    'toolbar-numlist': _toolbarNumlist2.default,
    'toolbar-quote-on': _toolbarQuoteOn2.default,
    'toolbar-quote': _toolbarQuote2.default,
    'toolbar-transparent-on': _toolbarTransparentOn2.default,
    'toolbar-transparent': _toolbarTransparent2.default,
    'toolbar-trash': _toolbarTrash2.default,
    'user-guest': _userGuest2.default
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/index.js
// module id = 1784
// module chunks = 0